import './src/styles/global-styles.css';

export const onClientEntry = () => {
  if (typeof window === 'undefined' || typeof console === 'undefined') return;

  const logo = `
                                ::::::::::
                   *********   ::::::::::  ++++++
                  **********   :::::::::: +++++++
                  **********   :::::::::: +++++++
    ++++++++++++++++********   :::::::::: *++++++  ++++++
    ++++++++++++++++++****** :::::::::::::::::::: +++++++
    ++++++++++++++++++****** ::::::::::::::::::::-+++++++
    ++++++++++++++++++ =     ::::::::::::::::::::-*++++++
    ++++++++++++++++++ ==    ::::::::::::::::::::=**********
    ++++++++++++++++++ ==    ::::::::::::::::::::+++++++++++
    ++++++++++++++++++  ==  =::::::::::::::::::::+++++++++++
*****+++++++++++++++++  =====::::::::::::::::::::+++++++++++
*****+++++++++++++++++   ====::::::::::::::::::::+++++++++++
*********+++++++++++++   ====::::::::::::::::::::+++++++++++
*********::::::::::     ====-::::::::::::::::::::+++++++++++
*********:::::::::::    ==== ::::::::::::::::::::+++++++++++
      ::::::::::::::   ===== :::::::::::=========+++++++++++
      :::::::::::::-   ====             +++++********+++++++
      :::::::::::::========           ==++++**********++++++
      ::::::::::::::=======         === ++++**********++++++
      :::::::::::::: ======      =====      **********
      :::::::::::::-  ===== ========        **********
                       ==========           **********
                       ========
                       =====
                       =====
                        =====
                        =====
                        ======
                         =====
                         ======
                          =======
                          =========
                        ===============
`;

  const logoStyle = 'color: #4FBC61; font-family: monospace; font-size: 10px; line-height: 1.05; font-weight: 600;';

  console.log('%c' + logo, logoStyle);

  console.log(
    '%cLooking for a job?%c Contact us at %cjobs@springtree.nl',
    'font-size: 14px; font-weight: 700; color: #1a1a1a;',
    'font-size: 13px; color: #4a4a4a;',
    'font-size: 13px; color: #4FBC61; font-weight: 700;'
  );
};
